// Note: The first file of a module here, must also register the module

import "./feature-auto-generate-voter-name-dialog.component";
import "./feature-extra-dialog.controller";
import "./feature-reception-dialog.component";
import "./feature-restricted-dialog.component";
import "./feature-settings.component";
import "./reception-feature-form.component";
import "./feature-disabled-dialog.component";
